import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerSW } from 'virtual:pwa-register';
import reportWebVitals from './reportWebVitals';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { setupIonicReact } from '@ionic/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
    QueryClientProvider,
} from '@tanstack/react-query'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { queryClient } from './query/queryClient';
import { installCurrentUserQueryListener } from './query/currentUserQuery';
import { installGatewayConnectionStateQueryListener } from './query/gatewayConnectionStateQuery';
import { installPushNotificationContextSync } from './client/OCPushNotificationContextSync';
import { installWatchSync } from './client/OCWatchSync';

setupIonicReact({
  innerHTMLTemplatesEnabled: true
});

CapacitorUpdater.notifyAppReady();

const container = document.getElementById('root');
const root = createRoot(container!);
const theme = createTheme({
  colorSchemes: {
    dark: true,
    light: false,
  },
});

installCurrentUserQueryListener(queryClient);
installGatewayConnectionStateQueryListener(queryClient);
installPushNotificationContextSync();
installWatchSync();

root.render(
    <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
            <App />
        <ReactQueryDevtools initialIsOpen={false} />
        </ThemeProvider>
    </QueryClientProvider>
);

// Register service worker with Vite PWA
const updateSW = registerSW({
  onNeedRefresh() {
    console.log('New content available, please refresh.');
  },
  onOfflineReady() {
    console.log('App ready to work offline.');
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
